.text {
  &__icon {
    display: inline-flex;
  }
}
